import styled from 'styled-components';

export const LocationAndContactWrapper = styled.div`
  background-color: #ffffff;
  padding: ${({ theme }) => `0px ${theme.spacing[16]} ${theme.spacing[20]} ${theme.spacing[16]}`};
  margin-bottom: ${({ theme }) => theme.spacing[40]};
  box-shadow: 1px 3px 10px -4px #d2d2d2;
  > .panel-Selector {
    align-items: center;
    border-top: 1px solid #d2d2d2;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-top: 20px;
    width: 100%;
  }
`;
